import { TRACK_VIEW_CART } from '~/redux/actions/types'

export const trackViewCart = () => {
  return {
    type: TRACK_VIEW_CART
  }
}
